//angular imports
import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { FormGroup } from "@angular/forms";

//local imports
import { Transforms } from "@app/shared";
import { AbstractProjectModel } from "@app/catalog-common";

@Component({
  selector: "project-selection-list",
  templateUrl: "./project-selection-list.component.html",
  styleUrl: "./project-selection-list.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProjectSelectionListComponent {
  public projects = input.required<AbstractProjectModel[]>();
  public id = input.required<string>();
  public formGroup = input.required<FormGroup>();
  public label = input<string>("Project");
  public required = input(false, {
    transform: Transforms.toBoolean,
  });
}
